 import React from "react";
import { 
  Box, 
  Typography, 
  styled, 
  useTheme, 
  useMediaQuery,
  Divider
} from "@mui/material";
import {
  Copyright as CopyrightIcon
} from "@mui/icons-material";

import { alpha } from '@mui/material/styles';


const FooterContainer = styled(Box)(({ theme, $collapsed }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  padding: theme.spacing(2.5),
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.drawer - 1,
  backdropFilter: "blur(10px)",
  background: `linear-gradient(to right, 
    ${alpha(theme.palette.background.paper, 0.8)}, 
    ${alpha(theme.palette.background.default, 0.9)})`,
  borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: `0 -4px 30px ${alpha(theme.palette.primary.main, 0.05)}`,
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard,
  }),
  marginLeft: $collapsed ? "80px" : "280px",
  width: $collapsed ? "calc(100% - 80px)" : "calc(100% - 280px)",
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
    width: "100%",
    padding: theme.spacing(1.5),
  },
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
  maxWidth: 1400,
  margin: "0 auto",
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  color: theme.palette.text.secondary,
}));

const ContactItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 1.5),
  borderRadius: "20px",
  background: alpha(theme.palette.primary.light, 0.1),
  transition: "all 0.3s ease",
  "&:hover": {
    background: alpha(theme.palette.primary.light, 0.2),
    transform: "translateY(-2px)",
  },
}));

const ContactLink = styled("a")(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  fontSize: "0.75rem",
  fontWeight: 500,
}));

const FooterDivider = styled(Divider)(({ theme }) => ({
  borderColor: alpha(theme.palette.divider, 0.1),
  width: "100%",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

function Footer({ collapsed }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <FooterContainer component="footer" $collapsed={collapsed}>
      <FooterContent>
        <FooterText variant="body2">
          <CopyrightIcon fontSize="inherit" />
          IPPIS {new Date().getFullYear()} | All rights reserved
        </FooterText>

        {!isMobile && (
          <Box sx={{ 
            position: "absolute", 
            left: "50%", 
            transform: "translateX(-50%)",
            display: "flex",
            gap: theme.spacing(0.5),
          }}>
          </Box>
        )}

     
         
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;